import React, { useLayoutEffect, useRef, useState, CSSProperties } from "react";
import { OverlayTriggerState } from "@react-stately/overlays";
import { DialogProps } from "@evidenceb/athena-common/design-system/Modal";
import { Modal } from "@evidenceb/athena-common/design-system/Modal";

import "./BottomSheet.scss";

export type PlaylistPanelBottomSheetProps = DialogProps & {
    state: OverlayTriggerState;
    dialogTitle?: string;
};

const BottomSheet = ({
    state,
    children,
    dialogTitle,
}: PlaylistPanelBottomSheetProps) => {
    const [headerHeight, setHeaderHeight] = useState<number>(0);

    const headerRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (headerRef.current) setHeaderHeight(headerRef.current.clientHeight);
    }, []);

    return (
        <Modal
            disableFooter
            onClose={() => state.close()}
            open={state.isOpen}
            title={
                dialogTitle && (
                    <div ref={headerRef} className="bottom-sheet-modal__header">
                        <h3 className="bottom-sheet-modal__title">
                            {dialogTitle}
                        </h3>
                    </div>
                )
            }
            aria-label={dialogTitle}
        >
            <div
                className="bottom-sheet-modal__body"
                style={{ "--header-height": headerHeight } as CSSProperties}
            >
                {children}
            </div>
        </Modal>
    );
};

export default BottomSheet;
